import Highlight from "@tiptap/extension-highlight"
import type { Slice } from "@tiptap/pm/model"
import { Plugin } from "@tiptap/pm/state"
import { clampColor } from "../../util/clamp-color"

/** The allowed highlight colors. */
export const HIGHLIGHT_COLORS: { name: string; color: string }[] = [
  { name: "Red", color: "rgb(245, 214, 216)" },
  { name: "Orange", color: "rgb(247, 225, 212)" },
  { name: "Yellow", color: "rgb(251, 251, 182)" },
  { name: "Green", color: "rgb(225, 236, 198)" },
  { name: "Teal", color: "rgb(207, 227, 217)" },
  { name: "Blue", color: "rgb(214, 238, 245)" },
  { name: "Navy", color: "rgb(207, 222, 237)" },
  { name: "Purple", color: "rgb(217, 212, 237)" },
  { name: "Magenta", color: "rgb(235, 209, 225)" },
]

// Cp mod: Clamp highlight colors to our allowed list when pasting.
export const CpHighlight = Highlight.extend({
  parseHTML() {
    return [
      ...(this.parent?.() ?? []),
      {
        tag: "span",
        consuming: false,
        getAttrs: (element) => {
          const bgColor = element.style.backgroundColor
          if (bgColor && bgColor !== "transparent") {
            return { color: bgColor }
          } else return false
        },
      },
    ]
  },

  addProseMirrorPlugins() {
    return [...(this.parent?.() ?? []), new Plugin({ props: { transformPasted } })]
  },
})

function transformPasted(slice: Slice): Slice {
  slice.content.descendants((node) => {
    for (const mark of node.marks) {
      if (mark.type.name === "highlight" && mark.attrs["color"]) {
        const clamped = clampColor(
          HIGHLIGHT_COLORS.map((entry) => entry.color),
          mark.attrs["color"] as string,
          // Highlight pastels are low-saturation, so only treat near-grays as
          // achromatic.
          0.05,
        )
        // Mutating mark attrs directly for paste-transform convenience; marks
        // are nominally immutable but this is safe inside transformPasted.
        // @ts-expect-error mark.attrs has no index signature
        mark.attrs = { ...mark.attrs, color: clamped }
      }
    }
  })
  return slice
}
